module.exports = require('./helpers/bundle-url').getBundleURL('aHK3C') + "logo.c51670a8.svg";